export default __webpack_public_path__ + "static/media/Elizabeth-Smedley.15c0920b.jpg";